import { render, staticRenderFns } from "./ip-access-toggle.vue?vue&type=template&id=a902fe1e"
import script from "./ip-access-toggle.vue?vue&type=script&lang=js"
export * from "./ip-access-toggle.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports